const e = `AI Experiences`,
  t = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  n = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Amazon Bedrock Foundation Models (FMs).`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `The custom prompts that instructors provide to create the AI experience and student conversation with the AI Experience tool.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `All conversation data and the activity context created by the instructor is saved.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Prompt data, LLM responses, and student responses are logged.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: ``,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Instructors set the parameters for each conversation, and students are informed they are interacting with AI. The AI’s output is delivered as-is, without post-editing. Instructors have full access to the conversation transcript.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Model responses are logged for quality assurance, and responses with low confidence are flagged "Needs Review" to encourage human intervention.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `The LLM might not ask the right questions or assess the conversation correctly. `,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `New type of learning activity that incorporates conversational AI in the process of learning, allowing students to demonstrate understanding of a topic and engage in a new learning modality within the LMS.`,
        },
      ],
    },
  ],
  r = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `AI Experiences`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `AI Experiences`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: t,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: n,
      nutritionFactsFeatureName: `AI Experiences`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: e,
      currentFeatureText: `Current Feature:`,
      data: t,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `AI Experiences is a new activity type, allowing instructors to design and assess interactive chat experiences with AI.`,
    group: `Canvas`,
    name: e,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: n,
      featureName: e,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.11.25`,
    uid: `aiexperiences`,
  },
  i = `Ask Your Data`,
  ee = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  a = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Doowii (multiple)`,
          valueDescription: `Doowii is a third-party sub-processor for Intelligent Insights. Doowii's tools use OpenAI GPT-4o, GPT-3.5 Turbo, and Claude Sonnet 3.5`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Doowii is trained on the Canvas LMS database schema, and receives no data from Canvas. The user's prompt and heuristics (such as summary statistics) are shared with the model to generate a response.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is retained through the life of your contract with Instructure.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: ``,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Exposed`,
          valueDescription: `Prompt, summary statistics.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Ask your data returns a methodology description along with a generated query. Users have the ability to edit the generated SQL directly.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Questions are scoped to the domain only, highly ambiguous terms ask for clarification.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Incorrect interpretation of the question. Inaccurate SQL may be generated. Suggested questions or methodologies may not be relevant.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Provide accurate data retrieval and analysis through natural language prompting.`,
        },
      ],
    },
  ],
  o = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Ask Your Data`,
          modelName: `Doowii (multiple)`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Ask Your Data`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: ee,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: a,
      nutritionFactsFeatureName: `Ask Your Data`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: i,
      currentFeatureText: `Current Feature:`,
      data: ee,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `AI-powered query tool enables users to ask natural language questions and receive textual or visual responses with detailed explanations of the methodology.`,
    group: `Intelligent Insights`,
    name: i,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: a,
      featureName: i,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.09.12`,
    uid: `askyourdata`,
  },
  s = `Item Authoring`,
  c = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  te = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Source material provided by the user (e.g., Custom standards, course content, text input, file input) for question/item generation.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Usage data is logged to improve the product.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in source material may be sent to the model if included by the user, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Instructors can review, edit, regenerate, or provide additional instructions to refine generated items.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Generated items may not perfectly capture all desired information, require refinement, or occasionally contain inaccuracies.
`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Improved instructor efficiency and productivity`,
        },
      ],
    },
  ],
  l = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Item Authoring`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Item Authoring`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: c,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: te,
      nutritionFactsFeatureName: `Item Authoring`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: s,
      currentFeatureText: `Current Feature:`,
      data: c,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Item Authoring for Assessments streamlines assessment creation by generating questions based on your course materials. 
`,
    group: `Mastery`,
    name: s,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: te,
      featureName: s,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.11.18`,
    uid: `assessmentauthoringassistance`,
  },
  u = `Course Accessibility Checker: Image alt text generation`,
  d = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  f = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Images uploaded to Canvas via RCX`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Usage data is logged to improve the product.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in source material may be sent to the model if included in the analyzed image, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Users can edit the generated alt text, and they have the option to save it or not.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `While the model can fairly accurately describe what's on a picture, it might not always convey what the picture is meant to convey in the given context. `,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Reduce time spent on writing alt text. `,
        },
      ],
    },
  ],
  p = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Course Accessibility Checker: Image alt text generation`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Course Accessibility Checker: Image alt text generation`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: d,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: f,
      nutritionFactsFeatureName: `Course Accessibility Checker: Image alt text generation`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: u,
      currentFeatureText: `Current Feature:`,
      data: d,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `A button that generates alt text for images that don't have alt text, or there was a problem identified with it (it's too long or it's just the filename.)`,
    group: `Canvas`,
    name: u,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: f,
      featureName: u,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2026.02.25`,
    uid: `canvasa11ycheckeralttextgenerator`,
  },
  m = `Course Accessibility Checker: Table caption generation`,
  ne = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  h = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Table to be generated caption for, along with some context (surrounding content) from the resource it's in.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Usage data is logged to improve the product.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in source material may be sent to the model if included in the analyzed content, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Users can edit the generated table caption, and they have the option to save it or not.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `It may not always accurately capture the point of the table.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Reduce time spent on writing table captions. `,
        },
      ],
    },
  ],
  re = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Course Accessibility Checker: Table caption generation`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Course Accessibility Checker: Table caption generation`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: ne,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: h,
      nutritionFactsFeatureName: `Course Accessibility Checker: Table caption generation`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: m,
      currentFeatureText: `Current Feature:`,
      data: ne,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `A button to generate table captions (based on the contents and immediate context of the table) for tables that don't have one.`,
    group: `Canvas`,
    name: m,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: h,
      featureName: m,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2026.02.19`,
    uid: `canvasa11ycheckertablecaptions`,
  },
  g = `Translations for Discussions & Announcements`,
  ie = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  ae = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Announcement and Discussion prompts and replies`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Does not log data`,
          valueDescription: ``,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in discussion replies may be sent to the model, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Untranslated content is available to review translations against`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Machine translation may not fully capture the meaning of the original message.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Improve participation for students who do not natively speak the language of instruction or other replies.`,
        },
      ],
    },
  ],
  oe = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Translations for Discussions & Announcements`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Translations for Discussions & Announcements`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: ie,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: ae,
      nutritionFactsFeatureName: `Translations for Discussions & Announcements`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: g,
      currentFeatureText: `Current Feature:`,
      data: ie,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Translation of Discussion threads ("Course AI Translation" feature flag) across 10 languages.`,
    group: `Canvas`,
    name: g,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: ae,
      featureName: g,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.09.10`,
    uid: `canvascoursetranslation`,
  },
  _ = `Summaries for Discussions`,
  v = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  y = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Amazon Bedrock Foundation Models (FMs).`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Discussion prompt and replies.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Summaries are logged in the Canvas database for review and reuse.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `Pii in discussion replies may be sent to the model, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Instructors may regenerate summaries or fine-tune them with additional instructions.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Summaries may not capture all desired information.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Summaries allow discussion topics to be used in large-format courses and other environments where discussions were previously infeasible.`,
        },
      ],
    },
  ],
  b = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Summaries for Discussions`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Summaries for Discussions`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: v,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: y,
      nutritionFactsFeatureName: `Summaries for Discussions`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: _,
      currentFeatureText: `Current Feature:`,
      data: v,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Discussion summaries of key points, questions, and insights.`,
    group: `Canvas`,
    name: _,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: y,
      featureName: _,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.09.12`,
    uid: `canvasdiscussionsummaries`,
  },
  x = `Grading Assistance`,
  S = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  C = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Assignment information, rubric, and student submissions.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Transactional data is retained for the life of the request.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Complete response from the LLM is retained in the Canvas database for auditing purposes.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `No PII is intentionally sent to the model. If there is incidental PII in any of the shared data, such as in the submission body, it will be sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Grade suggestion is displayed and selected by default, but the instructor must make the final decision to edit or accept the suggestions.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `The Claude Haiku model has inherent guardrails built in.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Grading Assistance does not flag unsafe content, verify facts or sources, enforce formatting or quantitative requirements, or reliably grade objective or single-answer questions. Results are based only on rubric criteria.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Reduced bias in grading, fairness, and consistency. Grading efficiency, saving teachers time.`,
        },
      ],
    },
  ],
  w = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Grading Assistance`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Grading Assistance`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: S,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: C,
      nutritionFactsFeatureName: `Grading Assistance`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: x,
      currentFeatureText: `Current Feature:`,
      data: S,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `AI powered automatic grading and feedback suggestions to enable more consistent, fair, and efficient grading workflows.`,
    group: `Canvas`,
    name: x,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: C,
      featureName: x,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.10.22`,
    uid: `canvasgradingassistance`,
  },
  T = `Translations for Inbox`,
  E = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  D = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `AWS Translate`,
          valueDescription: `AWS Translate model is provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Inbox messages`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Does not log data`,
          valueDescription: ``,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in inbox messages may be sent to the model but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Users are displayed the translated copy of their message and can edit or remove it before they send the message.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Machine translation may not fully capture the meaning of the original message.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Enable better multi-lingual communication in learning environments.`,
        },
      ],
    },
  ],
  O = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Translations for Inbox`,
          modelName: `AWS Translate`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Translations for Inbox`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: E,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: D,
      nutritionFactsFeatureName: `Translations for Inbox`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: T,
      currentFeatureText: `Current Feature:`,
      data: E,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Translation of inbox messages ("Inbox AI Translation" feature flag) across 10 languages.`,
    group: `Canvas`,
    name: T,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: D,
      featureName: T,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.09.10`,
    uid: `canvasinboxtranslation`,
  },
  k = `Learner Assist`,
  A = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  j = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Claude 3.5 Haiku, Cohere multi-language v3`,
          valueDescription: `Anthropic Claude and Cohere models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: ``,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: ``,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Chat logs are retained for 30 days for troubleshooting and debugging`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: ``,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `No`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: ``,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Content is restricted to the course content.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `AI Generated content may contain mistakes or inaccurate information and should always be verified`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `The intended outcome is to provide quicker and more efficient feedback to learners. `,
        },
      ],
    },
  ],
  M = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Learner Assist`,
          modelName: `Claude 3.5 Haiku, Cohere multi-language v3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Learner Assist`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: A,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: j,
      nutritionFactsFeatureName: `Learner Assist`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: k,
      currentFeatureText: `Current Feature:`,
      data: A,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `The Learner Assist provides immediate responses and suggested prompts that can aid learning, such as practice quizzes, flashcards, summaries, and key takeaways. `,
    group: `Canvas Career`,
    name: k,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: j,
      featureName: k,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2026.02.25`,
    uid: `careerassistant`,
  },
  N = `Standards Alignment for Quiz Conversion`,
  P = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  F = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Claude Family Models`,
          valueDescription: `Anthropic Claude models are provided via Amazon Bedrock Foundation Models (FMs).`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `The Canvas Quiz content and Mastery Tracker metadata (Subject, Objectives) is shared with the
model.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Standard execution, infrastructure, and other operational logs are retained for a reasonable period to enable monitoring and troubleshooting of underlying services.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Does not log data`,
          valueDescription: `No user data is logged at any time.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Virginia, Oregon`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: ``,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `The aligned standards can be reviewed and adjusted by educators prior to publishing the content.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `AI suggestions are limited to the standards present in the linked tracker’s standard set. This ensures that only the intended audience (educators) can use the tool and only relevant standards are suggested.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Expected risks include possible misalignment if AI suggestions are not carefully reviewed, reliance on the accuracy of the tracker’s standard set, and the need for educator oversight to ensure quality.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `The intended outcomes are to streamline the process of aligning assessments with learning standards, save educators time, and ensure consistency in assessment alignment.`,
        },
      ],
    },
  ],
  I = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Standards Alignment for Quiz Conversion`,
          modelName: `Claude Family Models`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Standards Alignment for Quiz Conversion`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: P,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: F,
      nutritionFactsFeatureName: `Standards Alignment for Quiz Conversion`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: N,
      currentFeatureText: `Current Feature:`,
      data: P,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `When importing Canvas Quizzes to Mastery Connect, AI can be used to suggest aligned standards.`,
    group: `Mastery`,
    name: N,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: F,
      featureName: N,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.11.19`,
    uid: `conversionalignment`,
  },
  L = `Insights for Discussions`,
  R = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  z = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Amazon Bedrock Foundation Models (FMs).`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Discussion topic, prompt, and student replies are used.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `No user data is stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Model evaluations and reply labels are logged for debugging and troubleshooting purposes.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Exposed`,
          valueDescription: `Known PII is masked before being sent to the model, though any PII present in the discussion reply is not and may be shared with the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Instructors may review AI-generated evaluations or review posts directly.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Model responses are logged for quality assurance, and responses with low confidence are flagged "Needs Review" to encourage human intervention.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `The model may misclassify some nuanced replies.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Instructors are able to quickly assess the quality of student replies, identify low-effort or off-topic contributions, and focus their attention to where it is needed most.`,
        },
      ],
    },
  ],
  B = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Insights for Discussions`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Insights for Discussions`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: R,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: z,
      nutritionFactsFeatureName: `Insights for Discussions`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: L,
      currentFeatureText: `Current Feature:`,
      data: R,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Discussion Insights uses AI to evaluate student discussion replies, highlight relevant contributions, and flag those that may need instructor review.`,
    group: `Canvas`,
    name: L,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: z,
      featureName: L,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.10.02`,
    uid: `discussioninsights`,
  },
  V = `Agent`,
  H = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  U = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3, Sonnet 3.7`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `The model uses chat transcripts and information requested from the Canvas API to execute its actions.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Chat logs are retained indefinitely for troubleshooting and debugging.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Chat logs are retained for troubleshooting and debugging purposes.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Virginia, Oregon`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Exposed`,
          valueDescription: `If requested during the the chat, user, course, and student identifiers or metadata may be shared with the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `The Agent only takes action based on human requests, and all write actions must be confirmed by the user.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Access to the Agent is limited to users with an Admin- or Teacher-based role. Data access and functions are scoped to the permissions available to the chat user.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `The model may misinterpret user requests and require additional prompting.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Users are able to save time by relying on the Agent to execute complex workflows, batch actions, and other time-consuming Canvas tasks.`,
        },
      ],
    },
  ],
  W = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Agent`,
          modelName: `Haiku 3, Sonnet 3.7`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: `AI Privacy Policy`,
          privacyNoticeUrl: `https://www.instructure.com/policies/artificial-intelligence-privacy`,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Agent`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: H,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: U,
      nutritionFactsFeatureName: `Agent`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: V,
      currentFeatureText: `Current Feature:`,
      data: H,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Ignite Agent is a faculty chat assistant capable of translating natural language requests into complex Canvas workflows.`,
    group: `IgniteAI`,
    name: V,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: U,
      featureName: V,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2026.01.14`,
    uid: `igniteagent`,
  },
  G = `Question Authoring`,
  K = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  q = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Source material provided by the user (e.g., Custom standards, course content, text input, file input) for question/item generation.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Usage data is logged to improve the product.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in source material may be sent to the model if included by the user, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Instructors can review, edit, regenerate, or provide additional instructions to refine generated items.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Generated items may not perfectly capture all desired information, require refinement, or occasionally contain inaccuracies.
`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Improved instructor efficiency and productivity`,
        },
      ],
    },
  ],
  se = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Question Authoring`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Question Authoring`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: K,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: q,
      nutritionFactsFeatureName: `Question Authoring`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: G,
      currentFeatureText: `Current Feature:`,
      data: K,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Question Authoring Assistance for Quizzes streamlines quiz creation by generating questions based on your course materials. 
`,
    group: `Canvas`,
    name: G,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: q,
      featureName: G,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.11.18`,
    uid: `itemauthoringassistance`,
  },
  J = `Portfolios`,
  ce = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  le = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Custom instructions that teachers provide in their Evaluation portfolios for students.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or re-used by the model.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Model evaluations and reply labels are logged for debugging and troubleshooting purposes.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: ``,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Teachers provide the input of the model (content) and the response by the model is not auto accepted. Teachers have the chance to modify the result every occasion.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Teacher access to the model is limited, it's only through the instructions of the portfolio/evidence. There is suspicious prompt detection built in for extra security.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `LLM might suggest not the right questions or skills, or not an improved instruction to the user's liking.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `A user-friendly tool for a safe writing assistant, and features to speed up administrative work, and provide more reliable portfolios for students to work with.`,
        },
      ],
    },
  ],
  ue = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Portfolios`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Portfolios`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: ce,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: le,
      nutritionFactsFeatureName: `Portfolios`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: J,
      currentFeatureText: `Current Feature:`,
      data: ce,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `AI Assistant for teachers to improve portfolio level and evidence level instructions improvement, skill extraction and reflection question generation.`,
    group: `Canvas`,
    name: J,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: le,
      featureName: J,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.10.27`,
    uid: `portfolios`,
  },
  Y = `Suggestions for Quick Reassess`,
  de = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  fe = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Instructure's in-house AI Platform.`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `The original question stem used to generate derivatives`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Standard execution, infrastructure, and other operational logs are retained for a reasonable period to enable monitoring and troubleshooting of underlying services.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Does not log data`,
          valueDescription: ``,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Virginia`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: ``,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Educators have access to tools that allow them to preview, regenerate, edit, or replace AI generated questions before they are published in an assessment.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `Only educators can generate items and all AI generated items are in draft status until reviewed and approved.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `AI generated questions may require additional review and editing to ensure accuracy, relevance, and alignment with intended learning objectives.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Educators can generate new standards-aligned questions based on existing items in order to quickly create diverse, tailored assessments that expand beyond the current Mastery Item Bank content, enhancing instructional flexibility and efficiency.`,
        },
      ],
    },
  ],
  pe = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Suggestions for Quick Reassess`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Suggestions for Quick Reassess`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: de,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: fe,
      nutritionFactsFeatureName: `Suggestions for Quick Reassess`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: Y,
      currentFeatureText: `Current Feature:`,
      data: de,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Allows the use of AI to generate a question derived from the original. These questions can be re-generated, edited, and rejected or approved before they are published to students.`,
    group: `Mastery`,
    name: Y,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: fe,
      featureName: Y,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.11.19`,
    uid: `quickreassess`,
  },
  X = `Generator for Rubrics`,
  me = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  he = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Haiku 3`,
          valueDescription: `Anthropic Claude models are provided via Amazon Bedrock Foundation Models (FMs).`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `The Canvas assignment description field is used in generating rubric criteria.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Model responses are stored for debugging purposes.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Logs data`,
          valueDescription: `Request, response, and feedback data is logged to assist in troubleshooting.`,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: ``,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `All created rubrics are reviewable and editable by the instructor.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: `The instructor may edit criteria before accepting the rubric.`,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `The created rubric may not align with the assignment's intended learning outcomes.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `A rubric aligned to learning outcomes is created for the instructor to use during grading.`,
        },
      ],
    },
  ],
  ge = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Generator for Rubrics`,
          modelName: `Haiku 3`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Generator for Rubrics`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: me,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: he,
      nutritionFactsFeatureName: `Generator for Rubrics`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: X,
      currentFeatureText: `Current Feature:`,
      data: me,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `AI-generated rubric recommendations for Canvas assignments.`,
    group: `Canvas`,
    name: X,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: he,
      featureName: X,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.10.09`,
    uid: `rubricgenerator`,
  },
  Z = `Search`,
  _e = [
    {
      description: `We leverage anonymized aggregate data for detailed analytics to inform model development and product improvements. No AI models are used at this level.`,
      highlighted: !1,
      level: `LEVEL 1`,
      title: `Descriptive Analytics and Research`,
    },
    {
      description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
      highlighted: !0,
      level: `LEVEL 2`,
      title: `AI-Powered Features Without Data Training`,
    },
    {
      description: `We customize AI solutions tailored to the unique needs and resources of educational institutions. We use customer data to fine-tune data and train AI models that only serve your institution. Your institution's data only serves them through trained models.`,
      highlighted: !1,
      level: `LEVEL 3`,
      title: `AI Customization for Individual Institutions`,
    },
    {
      description: `We established a consortium with educational institutions that shares anonymized data, best practices, and research findings. This fosters collaboration and accelerates the responsible development of AI in education. Specialized AI models are created for better outcomes in education, cost savings, and more.`,
      highlighted: !1,
      level: `LEVEL 4`,
      title: `Collaborative AI Consortium`,
    },
  ],
  ve = [
    {
      blockTitle: `Model & Data`,
      segmentData: [
        {
          description: `The foundational AI on which further training and customizations are built.`,
          segmentTitle: `Base Model`,
          value: `Cohere Embed Multilingual`,
          valueDescription: `Cohere models are provided via Amazon Bedrock Foundation Models (FMs).`,
        },
        {
          description: `Indicates the AI model has been given customer data in order to improve its results.`,
          segmentTitle: `Trained with User Data`,
          value: `No`,
        },
        {
          description: `Indicates which training or operational content was given to the model.`,
          segmentTitle: `Data Shared with Model`,
          value: `Course content is indexed by the model and then stored in the Canvas database.`,
        },
      ],
    },
    {
      blockTitle: `Privacy & Compliance`,
      segmentData: [
        {
          description: `How long the model stores customer data.`,
          segmentTitle: `Data Retention`,
          value: `Data is not stored or reused by the model. Indexed course content is stored in the Canvas database.`,
        },
        {
          description: `Recording the AI's performance for auditing, analysis, and improvement.`,
          segmentTitle: `Data Logging`,
          value: `Does not log data`,
          valueDescription: ``,
        },
        {
          description: `The locations where the AI model is officially available and supported.`,
          segmentTitle: `Regions Supported`,
          value: `Global`,
          valueDescription: ``,
        },
        {
          description: `Sensitive data that can be used to identify an individual.`,
          segmentTitle: `PII`,
          value: `Not Exposed`,
          valueDescription: `PII in course content may be indexed, but no PII is intentionally sent to the model.`,
        },
      ],
    },
    {
      blockTitle: `Outputs`,
      segmentData: [
        {
          description: `The ability to turn the AI on or off within the product.`,
          segmentTitle: `AI Settings Control`,
          value: `Yes`,
        },
        {
          description: `Indicates if a human is involved in the AI's process or output.`,
          segmentTitle: `Human in the Loop`,
          value: `Yes`,
          valueDescription: `Users are presented with a list of results related to their search query and can act or not act on them.`,
        },
        {
          description: `Preventative safety mechanisms or limitations built into the AI model.`,
          segmentTitle: `Guardrails`,
          value: ``,
        },
        {
          description: `Any risks the model may pose to the user.`,
          segmentTitle: `Expected Risks`,
          value: `Search results may be incorrectly sorted or may not be relevant to the search term.`,
        },
        {
          description: `The specific results the AI model is meant to achieve.`,
          segmentTitle: `Intended Outcomes`,
          value: `Students are able to quickly find answers to questions, and instructors are able to quickly navigate their courses.`,
        },
      ],
    },
  ],
  ye = {
    aiInformation: {
      data: [
        {
          description: `We utilize off-the-shelf AI models and customer data as input to provide AI-powered features. No data is used for training this model.`,
          featureName: `Search`,
          modelName: `Cohere Embed Multilingual`,
          modelNameText: `Base Model`,
          nutritionFactsModalTriggerText: `AI Nutrition Facts`,
          permissionLevel: `LEVEL 2`,
          permissionLevelText: `Permission Level:`,
          permissionLevelsModalTriggerText: `Data Permission Levels`,
          privacyNoticeText: ``,
          privacyNoticeUrl: ``,
        },
      ],
      dataPermissionLevelsCloseButtonText: `Close`,
      dataPermissionLevelsCloseIconButtonScreenReaderLabel: `Close dialog`,
      dataPermissionLevelsCurrentFeature: `Search`,
      dataPermissionLevelsCurrentFeatureText: `Current Feature:`,
      dataPermissionLevelsData: _e,
      dataPermissionLevelsModalLabel: `Data Permission Levels modal`,
      dataPermissionLevelsTitle: `Data Permission Levels`,
      nutritionFactsCloseButtonText: `Close`,
      nutritionFactsCloseIconButtonScreenReaderLabel: `Close`,
      nutritionFactsData: ve,
      nutritionFactsFeatureName: `Search`,
      nutritionFactsModalLabel: `This is a modal for AI facts`,
      nutritionFactsTitle: `AI Nutrition Facts`,
      title: `Features`,
      trigger: void 0,
    },
    dataPermissionLevels: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close dialog`,
      currentFeature: Z,
      currentFeatureText: `Current Feature:`,
      data: _e,
      modalLabel: `Data Permission Levels modal`,
      title: `Data Permission Levels`,
      triggerText: `Data Permission Levels`,
    },
    description: `Natural language search of course content for students and instructors.`,
    group: `Canvas`,
    name: Z,
    nutritionFacts: {
      closeButtonText: `Close`,
      closeIconButtonScreenReaderLabel: `Close`,
      data: ve,
      featureName: Z,
      modalLabel: `This is a modal for AI facts`,
      title: `AI Nutrition Facts`,
      triggerText: `Nutrition Facts`,
    },
    revision: `2025.10.02`,
    uid: `smartsearch`,
  },
  Q = (e, t) => {
    let n = {};
    for (let r in e) n[r] = e[r][t];
    return n;
  },
  $ = {
    aiexperiences: r,
    askyourdata: o,
    assessmentauthoringassistance: l,
    canvasa11ycheckeralttextgenerator: p,
    canvasa11ycheckertablecaptions: re,
    canvascoursetranslation: oe,
    canvasdiscussionsummaries: b,
    canvasgradingassistance: w,
    canvasinboxtranslation: O,
    careerassistant: M,
    conversionalignment: I,
    discussioninsights: B,
    igniteagent: W,
    itemauthoringassistance: se,
    portfolios: ue,
    quickreassess: pe,
    rubricgenerator: ge,
    smartsearch: ye,
  },
  be = Q($, `nutritionFacts`),
  xe = Q($, `dataPermissionLevels`),
  Se = Q($, `aiInformation`);
export {
  $ as AiInfo,
  $ as default,
  Se as aiInformation,
  r as aiexperiences,
  o as askyourdata,
  l as assessmentauthoringassistance,
  p as canvasa11ycheckeralttextgenerator,
  re as canvasa11ycheckertablecaptions,
  oe as canvascoursetranslation,
  b as canvasdiscussionsummaries,
  w as canvasgradingassistance,
  O as canvasinboxtranslation,
  M as careerassistant,
  I as conversionalignment,
  xe as dataPermissionLevels,
  B as discussioninsights,
  W as igniteagent,
  se as itemauthoringassistance,
  be as nutritionFacts,
  ue as portfolios,
  pe as quickreassess,
  ge as rubricgenerator,
  ye as smartsearch,
};
